import { booleanType, ensure, ensureArray, numberType, stringType, TType } from "types";

import { dateTimeType, TDateTime } from "@/core/dates";

export interface IId {
  id: number;
  signature: string;
}

export const configIdType = {
  id: numberType(NaN),
  signature: stringType(""),
};

export const idType = ensure<IId>(configIdType);

export interface IDatabaseUser {
  firstName: string;
  lastName: string;
}

export const configDatabaseUserType = {
  firstName: stringType(""),
  lastName: stringType(""),
};

export interface ISystemRecord {
  readonly systemId: string;
}

export const configSystemRecordType = {
  systemId: stringType(""),
};

export const databaseUserType = ensure<IDatabaseUser>(configDatabaseUserType);

export interface IDatabaseRecord extends IId {
  readonly createdBy: IDatabaseUser;
  readonly createdDate: TDateTime;
  readonly modifiedBy: IDatabaseUser;
  readonly modifiedDate: TDateTime;
}

export const configDatabaseRecordType = {
  ...configIdType,
  createdBy: databaseUserType,
  createdDate: dateTimeType(),
  modifiedBy: databaseUserType,
  modifiedDate: dateTimeType(),
};

export interface IErrorField<T = any> {
  field: string;
  code: string;
  value: T;
}

export const configErrorFieldType: TType<IErrorField> = {
  field: stringType(""),
  code: stringType(""),
  value: v => v,
};

export const errorFieldType = ensure<IErrorField>(configErrorFieldType);

export interface IErrorEntry<T = any> {
  code: string;
  errors: IErrorField[];
  value: T;
}

export const configErrorEntryType: TType<IErrorEntry> = {
  code: stringType(""),
  errors: ensureArray(errorFieldType),
  value: v => v,
};

export const errorEntryType = ensure<IErrorEntry>(configErrorEntryType);

export interface IPageableMeta {
  first: boolean;
  last: boolean;
  totalElements: number;
  numberOfElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export const configPageableMetaType: TType<IPageableMeta> = {
  first: booleanType(),
  last: booleanType(),
  totalElements: numberType(NaN),
  numberOfElements: numberType(NaN),
  totalPages: numberType(NaN),
  size: numberType(NaN),
  number: numberType(NaN),
};

export const pageableMetaType = ensure<IPageableMeta>(configPageableMetaType);

export interface IPageable<T> extends IPageableMeta {
  content: T;
}

export interface IPartialPageable<T> extends Partial<IPageable<T>> {}
